<template>
  <section class="advantages-panel">
    <div class="panel-title">核心优势</div>
    <div class="advantage-grid">
      <div v-for="item in advantages" :key="item.label" class="advantage-card">
        <i class="corner corner-tl"></i>
        <i class="corner corner-tr"></i>
        <i class="corner corner-bl"></i>
        <i class="corner corner-br"></i>
        <span class="advantage-label">{{ item.label }}</span>
        <strong class="advantage-value">{{ item.value }}</strong>
        <em class="bottom-light"></em>
      </div>
    </div>
  </section>
</template>

<script setup>
const advantages = [
  { label: "噪声过滤精度", value: "94.7%" },
  { label: "数据接入完整率", value: "96.2%" },
  { label: "生长分层等级", value: "5级" },
  { label: "多源数据兼容", value: "土壤｜气象｜植被｜灌溉" },
  { label: "长势跟踪误差降低", value: "16.3%" },
  { label: "产量预测误差降低", value: "12.8%" },
];
</script>

<style lang="less" scoped>
.advantages-panel {
  position: relative;
  min-height: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.panel-title {
  padding-left: 26px;
  color: #f3fcff;
  font-size: 34px;
  font-weight: bold;
  line-height: 42px;
  text-align: left;
}

.panel-title::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  width: 6px;
  height: 40px;
  background: #5ffff0;
  box-shadow: 0 0 12px rgba(95, 255, 240, 0.8);
}

.advantage-grid {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: 30px 38px;
  align-items: stretch;
}

.advantage-card {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 60px 24px;
  border: 1px solid rgba(94, 255, 244, 0.68);
  background:
    radial-gradient(ellipse at 50% 14%, rgba(80, 255, 238, 0.2), rgba(80, 255, 238, 0.04) 46%, transparent 76%),
    linear-gradient(180deg, rgba(7, 58, 56, 0.5), rgba(2, 37, 42, 0.98));
  box-shadow:
    inset 0 0 44px rgba(28, 244, 225, 0.2),
    inset 0 0 12px rgba(82, 255, 242, 0.12),
    0 0 14px rgba(36, 229, 214, 0.15);
}

.advantage-card::before,
.advantage-card::after {
  content: "";
  position: absolute;
  pointer-events: none;
}

.advantage-card::before {
  inset: 5px;
  border: 1px solid rgba(93, 255, 244, 0.1);
  box-shadow: inset 0 0 24px rgba(65, 255, 238, 0.16);
}

.advantage-card::after {
  left: 6px;
  right: 6px;
  bottom: 5px;
  height: 1px;
  background: linear-gradient(90deg, rgba(86, 255, 245, 0.18), rgba(123, 255, 247, 0.95), rgba(86, 255, 245, 0.18));
  box-shadow: 0 0 9px rgba(98, 255, 246, 0.85);
}

.corner {
  position: absolute;
  z-index: 2;
  width: 18px;
  height: 18px;
  border-color: #7ffff8;
  border-style: solid;
  filter: drop-shadow(0 0 5px rgba(116, 255, 247, 0.65));
}

.corner-tl {
  top: -1px;
  left: -1px;
  border-width: 3px 0 0 3px;
}

.corner-tr {
  top: -1px;
  right: -1px;
  border-width: 3px 3px 0 0;
}

.corner-bl {
  left: -1px;
  bottom: -1px;
  border-width: 0 0 3px 3px;
}

.corner-br {
  right: -1px;
  bottom: -1px;
  border-width: 0 3px 3px 0;
}

.bottom-light {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 62%;
  height: 10px;
  transform: translateX(-50%);
  background: radial-gradient(ellipse at center, rgba(104, 255, 247, 0.78), rgba(104, 255, 247, 0) 72%);
  pointer-events: none;
}

.advantage-label {
  position: relative;
  z-index: 1;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  line-height: 40px;
  text-align: center;
  text-shadow: 0 0 9px rgba(255, 255, 255, 0.34);
}

.advantage-value {
  position: relative;
  z-index: 1;
  max-width: 100%;
  margin-top: 4px;
  color: #8efff4;
  font-size: 54px;
  font-weight: bold;
  line-height: 64px;
  white-space: nowrap;
  text-align: center;
   background: linear-gradient(to top, #96F6F5, #DAFCFA);
  -webkit-background-clip: text;
  color: transparent;
}

.advantage-card:nth-child(4) .advantage-value {
  font-size: 30px;
  line-height: 40px;
  font-weight: bold;
}
</style>
